import React from "react";
import "./HomeItem.scss";

const HomeItem = ({ item, index }) => {
  const { title, excerpt, image, large } = item;

  return (
    <div className="homeItem-outer-container">
      <div className="homeItem-container">
        <div
          className={`homeItem-parent-container ${
            index % 2 === 0 ? "flex-reverse" : ""
          } `}
        >
          <img
            src={image}
            className={`home-item-image ${large ? "image-large" : ""}`}
            alt=""
          />
          <div
            className={`home-item-text ${
              index % 2 === 0 ? "flex-reverse" : ""
            }`}
          >
              <div className="head-text-2">{title}</div>
              {/* <div className='home-text'>{text}</div> */}
              <div
                className="card card-hover m-2 p-text-2"
                style={{ maxWidth: "20rem", backgroundColor: "#1abc9c" , borderRadius: '10px'}}
              >
                {/* <div className="card-header">{title}</div> */}
                {/* <div className="card-body"> */}
                {/* <h5 className="card-title">{title}</h5> */}
                <p className="card-text">{excerpt}</p>
                {/* </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* <div className='home-item-container'>
              <div className='home-item-column'>
                <article className='home-item-article'>
                  <h2 className='home-item-article__title'>{title}</h2>
                  <p className='home-item-article__excerpt'>{excerpt}</p>
                </article>
              </div>
            </div> */}
    </div>
  );
};

export default HomeItem;

// import React from "react";
// import "./HomeItem.scss";
// import { Card } from 'react-bootstrap';

// const HomeItem = ({ item, index }) => {
//   const { title, excerpt, image, large } = item;

//   return (
//     <div className="homeItem-outer-container">
//       <div className="homeItem-container">
//         <div
//           className={`homeItem-parent-container ${
//             index % 2 === 0 ? "flex-reverse" : ""
//           } `}
//         >
//           <img
//             src={image}
//             className={`home-item-image ${large ? "image-large" : ""}`}
//             alt=""
//           />
//           <div
//             className={`home-item-text ${
//               index % 2 === 0 ? "flex-reverse" : ""
//             }`}
//           >
//             {/* <Card style={{ width: '18rem' }}>
//               <Card.Header>Header</Card.Header>
//               <Card.Body>
//                 <Card.Title>Card Title</Card.Title>
//                 <Card.Text>
//                   Some quick example text to build on the card title and make up the bulk of
//                   the card's content.
//                 </Card.Text>
//               </Card.Body>
//             </Card> */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HomeItem;
